import { useEffect, useState } from 'react';

import { getOngoingApplicationService } from '../../api/getOngoingApplication';
import OngoingApplicationDialog from '../../components/OngoingApplicationDialog/OngoingApplicationDialog';
import { usePagesContext } from '../../context/PagesContext';
import { useAppSelector } from '../../hooks';
import useSettings from '../../hooks/useSettings';
import StatusErrorPage from '../StatusPage/ErrorPage/StatusErrorPage';

const CheckOngoingApplicationPage = () => {
    const { authenticationData } = useAppSelector((state) => state.authentication);
    const [applicationReferenceNumber, setApplicationReferenceNumber] = useState('');
    const settings = useSettings();
    const { pageAction, currentPage, setCurrentPage } = usePagesContext();
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        if (pageAction === 'back') {
            setCurrentPage(currentPage - 1);
        } else {
            setIsError(false);
            getOngoingApplicationService(settings.apiKey, settings.proxyBaseUrl, authenticationData)
                .then((applicationReferenceNumber) => {
                    if (applicationReferenceNumber) {
                        setApplicationReferenceNumber(applicationReferenceNumber);
                    } else {
                        setCurrentPage(currentPage + 1);
                    }
                })
                .catch(() => {
                    setIsError(true);
                });
        }
    }, [pageAction, currentPage, authenticationData]);

    return (
        <>
            {!isError && <OngoingApplicationDialog applicationReferenceNumber={applicationReferenceNumber} />}
            {isError && <StatusErrorPage />}
        </>
    );
};

export default CheckOngoingApplicationPage;
